//     							                          //
//  Program: MarketingSidebar.jsx                           //
//  Application: Marketing                                 //
//  Option: common component Marketing Sidebar TAbs        //
//  Developer: Ashish Kumar		                                  //
//  Date: 2022-04-02                                      //
//                                                        //
////////////////////////////////////////////////////////////

import React, { Component } from "react";
import { Link } from "react-router-dom";

class MarketingSidebar extends Component {
  constructor(props) {
    super(props);

    this.state = {
      pathname: window.location.pathname,
      property_slug: sessionStorage.getItem("property_slug") ? sessionStorage.getItem("property_slug") : "",
    };
  }

  isPathActive(path) {
    return window.location.pathname.includes(path);
  }

  toggleHeaderMenu(e) {
    e.preventDefault();
    document.querySelector(".mobchildMenu").classList.toggle("d-none");
    document.querySelector("body").classList.toggle("az-header-menu-show");
  }

  toggleChildMenu(e) {
    e.preventDefault();
    const data = document.querySelector(".left");
    data.classList.replace("left", "hide");
  }

  render() {
    return (
      <>
        <div className="deskchildMenu">
          <div
            className="backtosubMenu"
            onClick={(event) => this.toggleChildMenu(event)}
          >
            <i className="fas fa-chevron-left"></i>Back to CMS
          </div>
          <aside>
            <nav className="nav nav-pills flex-column pd-r-8">
              <ul>
                <li>
                  {/* <span>Information</span> */}
                  <ul>
                    {global.userPermissions.checkPermission(
                      "website-cms-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("property-cms-setting")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/properties/view/" +
                            (this.props.property_slug
                              ? this.props.property_slug
                              : this.state.property_slug) +
                            "/property-cms-setting"
                          }
                        >
                          Property Website
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission("app-cms-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("app-property-setting")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/properties/view/" +
                            (this.props.property_slug
                              ? this.props.property_slug
                              : this.state.property_slug) +
                            "/app-property-setting"
                          }
                        >
                          Property App
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              </ul>
            </nav>
          </aside>
        </div>
        <div className="mobchildMenu">
          <div className="d-flex justify-content-between align-items-center submenu">
             {/* New submenu */}
            <div className="newSubmenu">
            {/* <a href="/" className="back subMenu"> <i className="fas fa-chevron-left"></i> Listings</a> */}
            <span
              className="back"
              onClick={(event) => this.toggleHeaderMenu(event)}
            >
              <i className="fas fa-chevron-left"></i> Back to CMS
            </span>
              <ul>
                <li>
                  {/* <span>Information</span> */}
                  <ul>
                    {global.userPermissions.checkPermission(
                      "website-cms-list"
                    ) && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("website")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/properties/view/" +
                            (this.props.property_slug
                              ? this.props.property_slug
                              : this.state.property_slug) +
                            "/property-cms-setting"
                          }
                        >
                          Property Website
                        </Link>
                      </li>
                    )}
                    {global.userPermissions.checkPermission("app-cms-list") && (
                      <li>
                        <Link
                          className={
                            this.isPathActive("app-property-setting")
                              ? "nav-link active"
                              : "nav-link"
                          }
                          data-toggle="tab"
                          to={
                            "/properties/view/" +
                            (this.props.property_slug
                              ? this.props.property_slug
                              : this.state.property_slug) +
                            "/app-property-setting"
                          }
                        >
                          Property App
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </>
    );
  }
}
export default MarketingSidebar;
